import { PaySystem } from '@/api/models/finance'

import Acquiring from '../assets/Acquiring.svg'
import Amex from '../assets/AMEX.svg'
import Cup from '../assets/CUP.svg'
import Jcb from '../assets/JCB.svg'
import Mastercard from '../assets/MASTERCARD.svg'
import Mir from '../assets/MIR.svg'
import Qr from '../assets/Qr.svg'
import Visa from '../assets/VISA.svg'

type Props = {
  paySystem: PaySystem
}

export const PaySystemImage = ({ paySystem }: Props) => {
  switch (paySystem) {
    case PaySystem.Visa: {
      return <Visa />
    }
    case PaySystem.Mir: {
      return <Mir />
    }
    case PaySystem.Mastercard: {
      return <Mastercard />
    }
    case PaySystem.Amex: {
      return <Amex />
    }
    case PaySystem.Cup: {
      return <Cup />
    }
    case PaySystem.Jcb: {
      return <Jcb />
    }
    case PaySystem.Acquiring: {
      return <Acquiring />
    }
    case PaySystem.Qr: {
      return <Qr />
    }
    default: {
      return <Acquiring />
    }
  }
}
